import { makeStyles } from 'tss-react/mui';
import { fontWeights } from '../../styles/jss/variables';
const commonStyles = {
    width: '25px',
    height: '38px',
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
};
const useStyles = makeStyles()((theme) => ({
    azureMap: {
        height: '300px',
        position: 'relative',
        [theme.breakpoints.up('md')]: {
            height: '100%',
        },
        '& > div': {
            zIndex: '12 !important',
        },
    },
    fullHeight: {
        height: '100%',
    },
    withText: Object.assign(Object.assign({}, commonStyles), { backgroundImage: 'url(/images/maps/placewithnumber.svg)', color: 'white', textAlign: 'center', lineHeight: '31px', fontWeight: fontWeights.bold, fontSize: '0.85rem' }),
    wihtoutText: Object.assign(Object.assign({}, commonStyles), { backgroundImage: 'url(/images/maps/place.svg)' }),
}));
export default useStyles;
